/**
 * Le o arquivo como um buffer array
 * @param {Arquio que vai ser lido} inputFile
 */
const ReadFileAsArrayBuffer = (inputFile) => {
	const fileReader = new FileReader()

	return new Promise((resolve, reject) => {
		fileReader.onerror = () => {
			fileReader.abort()
			reject(new DOMException('Problem parsing input file.'))
		}

		fileReader.onload = (e) => {
			resolve(e.target.result)
		}
		fileReader.readAsArrayBuffer(inputFile)
	})
}

export { ReadFileAsArrayBuffer }
